import {Form, Input, Button, Checkbox, Typography} from 'antd';
import {useTranslation} from "react-i18next";
import {useUser} from "../../core/context/UserContext";
import {useEffect, useState} from "react";
import {use} from "i18next";
import {useHistory} from "react-router-dom";
import {Pages} from "../../AppRouter";
import ApiService from "../../core/service/api-service";

export default function LoginForm()
{
    const {t} = useTranslation();
    const {user, setToken, isAuth} = useUser();
    const history = useHistory();
    const [error, setError] = useState('')
    const [authParams, setAuthParams] = useState({
        enabled: false,
        key: null,
        timeout: 0,
        sms_auth: false,
        mail_auth: false,
        sms_text: '',
        mail_text: '',
    });

    const sendCode = async (type) => {
        const res = await ApiService.Auth.SendCode({
            code_key: authParams.key,
            code_type: type
        })

        if(res.success) {
            setAuthParams({
                ...authParams,
                enabled: true,
                key: res.data?.access_token,
                timeout: 60,
                sms_auth: authParams.sms_auth,
                mail_auth: authParams.mail_auth,
            })
            startTimer()
        }
    }

    const startTimer = () => {
        const interval = setInterval(() => {
            setAuthParams((prev) => {
                const nextTimeout = prev.timeout-1
                if(nextTimeout === 0) {
                    clearInterval(interval)
                }

                return {
                    ...prev,
                    timeout: prev.timeout-1
                }
            })
        }, 1000)
    }

    const signIn = async (form) => {
        if(!authParams.enabled) {
            const response = await ApiService.Auth.Login(form)
            if(response.success) {
                if(response.data.sms_auth || response.data.mail_auth) {
                    setAuthParams({
                        enabled: true,
                        sms_auth: response.data.sms_auth,
                        mail_auth: response.data.mail_auth,
                        timeout: 0,
                        key: response.data?.access_token,
                        sms_text: response.data.sms_text,
                        mail_text: response.data.mail_text,
                    })
                }
                else {
                    setToken(response.data?.access_token)
                }
            }
            else {
                setError('Username or password is incorrect!')
            }
        }
        else {
            const verifyResponse = await ApiService.Auth.SmsVerify({
                password: form.code,
                code_key: authParams.key
            })

            if(verifyResponse.success) {
                setToken(verifyResponse.data?.access_token)
            }
            else {
                setError(t('Verification code is wrong!'))
            }
        }
    }

    const redirectToHome = () => {
        if(isAuth())
        {
            history.push(Pages.Study.Study)
        }
        else {
            localStorage.removeItem('token')
        }
    }

    useEffect(() => {
        redirectToHome()
    }, [])

    useEffect(() => {
        redirectToHome()
    }, [user])

    return (
        <>
            <Form
                name="basic"
                layout={'vertical'}
                initialValues={{ remember: true }}
                autoComplete="off"
                onFinish={signIn}
            >
                <Form.Item
                    label={t('Username')}
                    name="username"
                    rules={[{ required: true, message: t('Please input your username!') }]}
                >
                    <Input size={'large'} />
                </Form.Item>

                {
                    !authParams.enabled && (
                        <Form.Item
                            label={t('Password')}
                            name="password"
                            rules={[{ required: true, message: t('Please input your password!') }]}
                        >
                            <Input.Password disabled={authParams.enabled} size={'large'} />
                        </Form.Item>
                    )
                }

                {
                    authParams.enabled && (
                        <>
                            <Form.Item
                                label={' '}
                                colon={false}
                            >
                                <div style={{width: '100%', wordWrap: 'break-word', wordBreak: 'break-word'}}>
                                    {t('You need to verify the security code to log in to your account.')}
                                </div>
                                <div style={{marginTop: 8, display: 'flex', flexDirection: 'column', gap: 8}}>
                                    {
                                        authParams.sms_auth && (
                                            <Button
                                                size={'large'}
                                                style={{width: '100%', height: 45, whiteSpace: 'normal', wordBreak: 'break-word'}}
                                                disabled={authParams.timeout > 0}
                                                onClick={() => {
                                                    sendCode('sms')
                                                }}
                                            >
                                                {t('SMS') + ` (*** *** **${authParams.sms_text})`}
                                            </Button>
                                        )
                                    }
                                    {
                                        authParams.mail_auth && (
                                            <Button
                                                size={'large'}
                                                style={{width: '100%', height: 45, whiteSpace: 'normal', wordBreak: 'break-word'}}
                                                disabled={authParams.timeout > 0}
                                                onClick={() => {
                                                    sendCode('mail')
                                                }}
                                            >
                                                {t('Mail') + ` (${authParams.mail_text})`}
                                            </Button>
                                        )
                                    }
                                </div>
                            </Form.Item>
                            {
                                authParams.timeout > 0 && (
                                    <Form.Item
                                        label={t('Code')}
                                        name="code"
                                        rules={[{required: true, message: t('Please input sms verification code!') }]}
                                    >
                                        <Input
                                            size={'large'}
                                            // type={'hidden'}
                                            addonAfter={(
                                                <div>
                                                    {authParams.timeout > 0 && ` (${authParams.timeout})`}
                                                </div>
                                            )}
                                        />
                                    </Form.Item>
                                )
                            }
                        </>
                    )
                }

                <Typography.Text style={{color: '#ff0000', fontWeight: 'bold'}}>
                    {t(error)}
                </Typography.Text>

                {
                    ((authParams.enabled && authParams.timeout > 0) || !authParams.enabled) && (
                        <Form.Item>
                            <Button
                                style={{width: '100%', height: 40}}
                                type="primary"
                                htmlType="submit"
                            >
                                {
                                    !authParams.enabled ? t('Login') : t('Send')
                                }
                            </Button>
                        </Form.Item>
                    )
                }
            </Form>
        </>
    )
}
